import {createContext, type Dispatch, type PropsWithChildren, type SetStateAction, use, useMemo, useState} from 'react'

export type NestedListItemDescriptionContextProps = {
  /**
   * The description of the list item.
   * NestedListItem description is composed from the aria-label property of the NestedListItem.DescriptionItem children
   * Used for the aria-label of the list item
   */
  description: string
  setDescription: Dispatch<SetStateAction<string>>
}

const NestedListItemDescriptionContext = createContext<NestedListItemDescriptionContextProps | undefined>(undefined)

export const NestedListItemDescriptionProvider = ({children}: PropsWithChildren) => {
  const [description, setDescription] = useState('')
  const contextProps = useMemo(
    () => ({description, setDescription}) satisfies NestedListItemDescriptionContextProps,
    [description],
  )
  return <NestedListItemDescriptionContext value={contextProps}>{children}</NestedListItemDescriptionContext>
}

export const useNestedListItemDescription = () => {
  const context = use(NestedListItemDescriptionContext)
  if (!context) throw new Error('useNestedListItemDescription must be used with NestedListItemDescriptionProvider.')
  return context
}

try{ NestedListItemDescriptionContext.displayName ||= 'NestedListItemDescriptionContext' } catch {}
try{ NestedListItemDescriptionProvider.displayName ||= 'NestedListItemDescriptionProvider' } catch {}